import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

import SocialLinks from '@components/SocialLinks'
import media from '@styles/media'

// SHAME : double slash hack to avoid going nower after url trailing slash removal
// TODO: find where is mangled the trailing slash and avoid it for '/'
const mobileLinks = [
  { to: '/', text: 'Home' },
  { to: '/about', text: 'About', disabled: true },
  { to: '/things', text: 'Things', disabled: false },
  { to: '/contact', text: 'Contact' },
]

/**
 * The fixed navigation sitting "behind" the mobile version
 * All the link functionality is taken over by the passed in navigateOut()
 * function that delays and allows us to animate between states.
 *
 * @param navigateOut
 */
const NavigationMobile = ({
  active,
  navigateOut,
}: {
  active: boolean
  navigateOut: (Event, string, boolean) => void
}) => {
  const isActive = active ? active : undefined

  return (
    <Frame active={isActive}>
      <SocialIconsHeader active={isActive}>
        <SocialLinks fill="#fff" />
      </SocialIconsHeader>
      <HorizontalRule active={isActive} />
      <MobileLinks active={isActive}>
        {mobileLinks.map((link, index) => (
          <StyledLink
            active={isActive}
            disabled={link.disabled}
            key={link.to}
            index={index}
            to={link.to}
            onClick={(event) => navigateOut(event, link.to, link.disabled)}
            getProps={({ isPartiallyCurrent, isCurrent }) =>
              isPartiallyCurrent && isCurrent
                ? { ['data-active']: 'true' }
                : null
            }
          >
            {link.text}
          </StyledLink>
        ))}
      </MobileLinks>
    </Frame>
  )
}
export default NavigationMobile

const Frame = styled.nav`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 0;
  padding: 80px 0;
  height: 100vh;
  background: ${(p) => (p.active ? '#1d2128' : '#08080b')};
  transition: background 0s ${(p) => (p.active ? '0' : '0.5s')};

  @media screen and (max-height: 700px) {
    padding: 40px 0;
  }

  ${media.desktop_up`
    display: none;
    visibility: hidden;
  `}
`

const SocialIconsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 60px;

  opacity: ${(p) => (p.active ? 1 : 0)};
  transform: translateY(${(p) => (p.active ? 0 : -12)}px);
  transition: all 0.5s var(--ease-out-quad) 100ms;

  @media screen and (max-height: 700px) {
    margin-bottom: 40px;
  }
`

const HorizontalRule = styled.hr`
  border: none;
  height: 1px;
  background: rgba(255, 255, 255, 0.25);
  margin: 0 40px 65px;

  opacity: ${(p) => (p.active ? 1 : 0)};
  transform: scaleX(${(p) => (p.active ? 1 : 0.6)});
  transition: transform 0.5s var(--ease-out-quad), opacity 0.4s ease-out;

  @media screen and (max-height: 700px) {
    margin: 0 40px 25px;
  }
`

const MobileLinks = styled.div`
  display: flex;
  flex-direction: column;
`
// TODO: implement theming!!!
const StyledLink = styled(Link)`
  position: relative;
  font-size: 1.9rem;
  color: #fff;
  display: inline-block;
  margin: 0 auto;
  text-align: center;

  opacity: ${(p) => (p.active ? (p.disabled ? 0.15 : 1) : 0)};
  transform: translateY(${(p) => (p.active ? 0 : -10)}px);
  transition: all 0.5s cubic-bezier(0.32, 0.08, 0.24, 1)
    ${(p) => p.index * 28 + 175}ms;

  &[data-active='true'] {
    color: #fff;
    &::after {
      content: '';
      position: absolute;
      margin: 0 auto;
      left: 0;
      right: 0;
      bottom: 10px;
      height: 1px;
      width: 20px;
      background: #fff;
    }
  }

  padding: 15px;
  margin-bottom: 5px;

  @media screen and (max-height: 700px) {
    margin-bottom: 0;
  }
`
